import React from 'react'
import ADEELS from "../Assets/bhatti88.jpg";
const Rightpage2 = () => {
  return (
    <div id="about">
         <div className="px-6 py-12">
      {/* Heading */}
      <h2 className="text-3xl font-bold text-black relative inline-block">
        About
        {/* Underline */}
        <span className="block w-10 h-1 bg-blue-400 mt-2"></span>
      </h2>

      {/* Description */}
      <p className="mt-4 text-gray-700  ">
        I'm Talal Haider, a passionate Electrical Engineer with a strong foundation in electronics, embedded systems, and power systems. I hold a Bachelor's degree in Electrical Engineering and specialize in designing circuits, programming microcontrollers, and simulating electrical systems using MATLAB and Proteus.

I'm proficient in tools like AutoCAD Electrical, Arduino, and LabVIEW, and have hands-on experience in IoT-based projects and renewable energy systems.

My passion lies in building smart, efficient, and sustainable solutions. I believe in continuous learning and thrive in collaborative environments where innovation and technology come together to solve real-world problems.
        
      </p>
    </div>
    <div>
         <div className="flex flex-col md:flex-row items-center md:items-start p-8 gap-16 ">
      
      {/* Left: Image */}
      <div className="w-full bg-white shadow-lg rounded-lg max-w-4xl  mx-auto md:w-1/3 mb-6 md:mb-0 ">
        <img
          src={ADEELS}
          alt="Profile"
          className="rounded-lg object-cover w-full h-[430px]"
        />
      </div>

      {/* Right: Details */}
      <div className="md:w-2/3 md:pl-8">
        <h2 className="text-2xl font-bold mb-2">
          Electrical Engineer
        </h2>
        <p className="italic text-gray-600 mb-8 mt-8">
          Pain itself is meaningless, but we use it as placeholder text. It talks about working hard and enduring pain to achieve something great.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <p className='text-2xl'><span className="font-semibold text-2xl">Birthday:</span><span className='italic text-gray-600'>20 May 2002</span></p>
            <p className='text-2xl pt-6'><span className="font-semibold">Website:</span><span className='text-gray-600'> www.example.com</span></p>
            <p className='text-2xl pt-6'><span className="font-semibold">Phone:</span><span className='text-gray-600'>0316-0049-870</span></p>
            <p className='text-2xl pt-6'><span className="font-semibold ">City:</span><span className='text-gray-600'> Islamabad,Pakistan</span></p>
          </div>
          <div>
            <p className='text-2xl'><span className="font-semibold">Age:</span><span className='text-gray-600'>22</span></p>
            <p className='text-2xl pt-6'><span className="font-semibold">Degree:</span><span className='text-gray-600'>Bachelor</span></p>
            <p className='text-2xl pt-6'><span className="font-semibold">Email:</span><span className='text-gray-600'>talalhaidermushtaq<br/>@gmail.com</span></p>
            <p className='text-2xl pt-6'> <span className="font-semibold">Freelance:</span><span className='text-gray-600'>Available</span></p>
          </div>
        </div>

        <p className="mt-4 text-gray-700 text-sm">
         By choosing responsibilities, we take on work and accept pain and hardship…
        </p>
      </div>
    </div>
        </div>     
    </div>
  )
}

export default Rightpage2
